import "./not-found.scss";

const NotFound = () => {
  return <div>NOT FOUND</div>;
};

export default NotFound;
